/** Client helpers — recalc via backend (logique /calcul). */

import { classifyArticleHeuristic } from './stockProductClassify';

export const DEFAULT_DOUANE = 35;
export const DEFAULT_MARGE = 50;

export async function recalcInvoiceProducts(api, { produits, frais_port_total, douane_pct, marge_pct }) {
  const res = await api.post('/stock/import-invoice/recalc', {
    produits,
    frais_port_total,
    douane_pct,
    marge_pct,
  });
  return res.data;
}

export const isInvoicePhoneLine = (p) => (
  p?.is_phone === true || classifyArticleHeuristic(p?.categorie, p?.designation, p?.reference, { is_phone: p?.is_phone, is_piece: p?.is_piece }).needsImei
);

export const getInvoiceImeiList = (p) => {
  const qty = Math.max(1, Number(p?.quantite) || 1);
  let list = [];
  if (Array.isArray(p?.imei_list) && p.imei_list.length) list = [...p.imei_list];
  else if (Array.isArray(p?.imeis) && p.imeis.length) list = [...p.imeis];
  else if (p?.imei) list = [p.imei];
  while (list.length < qty) list.push('');
  return list.slice(0, qty);
};

export const countFilledImeis = (p) => getInvoiceImeiList(p).filter((x) => String(x || '').trim().length >= 14).length;

export const patchInvoiceImeis = (product, imeiList) => {
  const cleaned = imeiList.map((x) => String(x || '').replace(/\D/g, '').slice(0, 20));
  const filled = cleaned.filter((x) => x.length >= 14);
  const qty = Math.max(1, Number(product.quantite) || 1);
  return {
    ...product,
    imei_list: cleaned,
    imei: filled[0] || '',
    imeis: filled,
    imei_missing: Math.max(0, qty - filled.length),
  };
};
